import React from "react";
import "./styles.scss";
import { BannerTagline } from "molecules";

export default props => (
  <div className="section-banner-container">
    <div className="section-banner">
      <BannerTagline text={props.title} center />
    </div>
  </div>
);
